import AGSRetriggerFreespins from "ags/states/ags-retrigger-freespins";
import llGatewayCelebrationComponent from "components/ll-gateway-celebration-component";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";

export default class LLRetriggerFreespins extends AGSRetriggerFreespins {
    protected showPrompt(prompt?: PromptContent) {
        llGatewayCelebrationComponent.playFreespinsCelebration().then(() => {
            Components.matrix.resetSymbols();
            super.showPrompt(prompt);
        });
    }
}
